import { useCallback, useEffect, useState } from 'react';
export var LoadingState;
(function(LoadingState) {
    LoadingState[/**
     * Data has not yet loaded or not been loading.
     */ "NotLoaded"] = "NotLoaded";
    LoadingState[/**
     * Data is in the process of being fetched.
     */ "Loading"] = "Loading";
    LoadingState[/**
     * Data was successfully retrieved.
     */ "Success"] = "Success";
    LoadingState[/**
     * An error occurred while retrieving the data.
     */ "Failure"] = "Failure";
})(LoadingState || (LoadingState = {}));
/**
 * Loads an action on mount, or on refresh. Returns the actions LoadActionState.
 * @param loadAction The asynchronous load method. Must be wrapped in useCallback if using an inline function to prevent unnecessary re-renders.
 *
 * For example:
 * ```typescript
 * // Basic
 * const { loadingState } = useLoadAction(loyaltyDomain.actions.member.loadMember);
 *
 * // With callback
 * const loadAction = useCallback(() => {
 *     browsingDomain.actions.films.loadFilmById(filmId), [filmId]);
 * });
 * const { loadingState } = useLoadAction(loadAction);
 * ```
 */ export const useLoadAction = (loadAction)=>{
    const [loadingState, setLoadingState] = useState('Loading');
    const loadCallback = useCallback(()=>{
        (async ()=>{
            try {
                setLoadingState('Loading');
                await loadAction();
                setLoadingState('Success');
            } catch (error) {
                setLoadingState('Failure');
            }
        })();
    }, [
        loadAction
    ]);
    useEffect(loadCallback, [
        loadCallback
    ]);
    return {
        loadingState,
        reload: loadCallback
    };
};
